import { Navigate } from '@tanstack/react-router';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { useAnalyticsProfileContext } from '../analytics-profile-context';
import { AnalyticsInstagramHashtags } from './analytics-instagram-hashtags';

export const AnalyticsHashtag = () => {
  const { selectedSocialAccount } = useAnalyticsProfileContext();

  switch (selectedSocialAccount.socialMedia) {
    case AnalyticsSupportedSocialMediaType.instagram:
      return <AnalyticsInstagramHashtags />;
    default:
      return <Navigate to="/analytics" />;
  }
};
